import React from 'react';
import LastPublications from '../../dashboard/components/LastPublications/LastPublications';
import Navbar from '../../navbar/Navbar';
import { useSelector } from 'react-redux';
import { RootState } from '../../rootReducer';
import NextPublication from '../../dashboardsso/SsoComponents/NextPublication/NextPublication';
import NetworkAdmin from '../AdminComponents/NetworkAdmin/NetworkAdmin';
import Help from '../../dashboardsso/SsoComponents/Help/Help';
import InfoAdmin from './InfoAdmin/InfoAdmin';
import { AddPublicationButton } from '../../addPublicationButton/AddPublicationButton';
import backgroundImageSso from '../../assets/background_sso.png';
import backgroundImageHandPhone from '../../assets/sso/hand_phone.png';
import Footer from '../../footer/Footer';

function DashboardAdmin() {
    const userEmail = useSelector((state: RootState) => state.user.email);
    const email = userEmail?.split('@')[0];
    return (
        <div className="overflow-x-hidden">
            <div className="inline-flex flex-1 relative w-full self-stretch overflow-x-hidden">
                <div>
                    <Navbar />
                </div>
                <div className="overflow-x-hidden w-full">
                    <div className="flex flex-col items-start relative h-full">
                        <div className="flex flex-col h-full px-[36px] pt-[35px] w-full max-w-full">
                            <div className="flex items-center self-stretch justify-between relative w-full pb-[30px]">
                                <div
                                    className="flex px-9 py-4 w-full rounded"
                                    style={{
                                        background: `linear-gradient(90deg, #fff 0%, #fff 60%, transparent), url(${backgroundImageSso}) no-repeat right 0 bottom 10% / 45%`,
                                    }}
                                >
                                    <div className="flex-1 inline-flex flex-col justify-start items-start gap-0.5">
                                        <div className="self-stretch justify-start  text-neutral-900 text-3xl font-semibold leading-loose">
                                            Bonjour{' '}
                                            {email
                                                ? email.charAt(0).toUpperCase() + email.slice(1)
                                                : email}
                                        </div>
                                        <p className="self-stretch justify-center text-neutral-700 text-sm font-normal font-['Montserrat'] leading-tight">
                                            Bienvenue sur votre espace pour gérer la communication
                                            de vos agences sur les réseaux sociaux !
                                        </p>
                                    </div>
                                    <AddPublicationButton></AddPublicationButton>
                                </div>
                            </div>
                            <div className="flex flex-1 self-auto gap-[20px]">
                                <div className="relative flex flex-grow flex-shrink-0 basis-[33.33%] min-w-0">
                                    <div className="flex flex-1">
                                        <LastPublications />
                                    </div>
                                </div>
                                <div className="flex flex-col flex-grow-[2] flex-shrink-0 basis-[66.67%] min-w-0 h-auto">
                                    <div
                                        className="w-full rounded h-[20%] min-h-[198px] flex justify-center shadow-lg"
                                        style={{
                                            background:
                                                'linear-gradient(275.26deg, #62AA47 4.22%, #BED000 96.79%)',
                                        }}
                                    >
                                        <InfoAdmin />
                                    </div>
                                    <div className="flex w-full h-full pt-[1em] gap-[1.5em]">
                                        <div className="flex flex-col justify-between shadow-lg bg-white max-h-full w-full rounded gap-[1.25em] p-[1.5em_1.25em]">
                                            <NextPublication />
                                        </div>
                                        <div className="flex flex-col w-full gap-[1.5em] h-full">
                                            <div className="bg-white h-[50%] max-w-full rounded p-[1.25em] shadow-lg">
                                                <NetworkAdmin />
                                            </div>
                                            <div
                                                className="
                                                overflow-hidden
                                                h-[50%] max-w-full rounded-[var(--border-radius)] relative
                                                gap-5 px-5 py-6 text-white text-super-medium font-medium break-words
                                                bg-[rgba(98,170,71,1)] shadow-lg"
                                            >
                                                <img
                                                    src={backgroundImageHandPhone}
                                                    alt="img hand phone"
                                                    className="absolute right-2 -bottom-6 w-72 overflow-hiden"
                                                />
                                                <Help />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full px-8 myt-6 mt-8 mb-10">
                            <Footer></Footer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardAdmin;
